import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN,
  LOGS_SISTEMA_LISTAR_LOGS_RPA_SUCCESS,
  LOGS_SISTEMA_LISTAR_LOGS_RPA_FAILURE,
  LOGS_SISTEMA_LISTAR_LOGS_RPA_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';
import initialState from './initialState';

export function listarLogsRpa(filter = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN,
    filter,
  };
}

export function dismissListarLogsRpaError() {
  return {
    type: LOGS_SISTEMA_LISTAR_LOGS_RPA_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN actions
export function* doListarLogsRpa(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const LogProcessamentoRPAApi = new Services['LogProcessamentoRPAApi']();
    res = yield LogProcessamentoRPAApi.find(action.filter);
  } catch (err) {
    yield put({
      type: LOGS_SISTEMA_LISTAR_LOGS_RPA_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGS_SISTEMA_LISTAR_LOGS_RPA_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListarLogsRpa() {
  yield takeLatest(LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN, doListarLogsRpa);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGS_SISTEMA_LISTAR_LOGS_RPA_BEGIN:
      return {
        ...state,
        listaLogsRpa: initialState.listaLogsRpa,
        listarLogsRpaPending: true,
        listarLogsRpaError: null,
      };

    case LOGS_SISTEMA_LISTAR_LOGS_RPA_SUCCESS:
      return {
        ...state,
        listaLogsRpa: action.data,
        listarLogsRpaPending: false,
        listarLogsRpaError: null,
      };

    case LOGS_SISTEMA_LISTAR_LOGS_RPA_FAILURE:
      return {
        ...state,
        listarLogsRpaPending: false,
        listarLogsRpaError: action.data.error,
      };

    case LOGS_SISTEMA_LISTAR_LOGS_RPA_DISMISS_ERROR:
      return {
        ...state,
        listarLogsRpaError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/logs-sistema/redux/listarLogsRpa.js